import React from 'react';

const date = new Date();

const footerObj = {
    name: 'Kakkara Dental Clinic',
    date: date.getFullYear()
};

const styleSheet = {
  container:{
      background: '',
      left:'0px',
      right:'0px',
      width: '100vw',
      padding:'2em',
      color: '#00cd96',
      backgroundColor: '#00cd96'
  },
  footer:{
      textAlign: 'center'
  }
};

class Footer extends React.Component {
    render(){
        return (
          <div style={styleSheet.container}>
            <footer style={styleSheet.footer}>
              <p>&copy; {footerObj.date} - {footerObj.name}</p>
            </footer>
          </div>
        );
    }
}


export default Footer;



// WEBPACK FOOTER //
// ./src/Footer/Footer.jsx